import GeolocatorEvents from '@Core/components/geolocator/events';
import MapMarker from '@Core/components/map/mapMarker';
import Events from './events';

const initObserver = (sectionToObserve) => {
  // Add offset on top/bottom to initialize loading before section enters screen
  const observerOptions = {
    rootMargin: '10% 0% 10% 0%',
  };

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !window.locationSearchMap) {
        window.dispatchEvent(Events.MapInView);
        observerInstance.disconnect();
      }
    });
  }, observerOptions);

  observer.observe(sectionToObserve);
};

const updateUrlParams = (params = []) => {
  const { history } = window;
  const { pathname } = window.location;

  if (!params) {
    history.replaceState(null, null, pathname);
    return;
  }

  const searchParams = new URLSearchParams();
  params.forEach((param) => searchParams.set(param.key, param.value));
  const updatedUrl = `${pathname}?${searchParams.toString()}`;

  history.replaceState(null, null, updatedUrl);
};

const geolocate = () => {
  window.dispatchEvent(GeolocatorEvents.Geolocate);
};

const createUserPin = (lng, lat) => new MapMarker({
  id: 'user',
  longitude: lng,
  latitude: lat,
  icon: 'userIcon',
});

export {
  createUserPin, geolocate, initObserver, updateUrlParams,
};
